import { render, staticRenderFns } from "./FiservCodeMappings.vue?vue&type=template&id=4bc7f135&scoped=true"
import script from "./FiservCodeMappings.vue?vue&type=script&lang=ts"
export * from "./FiservCodeMappings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7f135",
  null
  
)

export default component.exports